export const ACCOUNT_BASE_PATH = '/account';

export const ACCOUNT_USER_PROFILE_PATH = `${ACCOUNT_BASE_PATH}/user_profile`;
export const ACCOUNT_SCHOOL_PROFILE_PATH = `${ACCOUNT_BASE_PATH}/school_profile`;
export const ACCOUNT_STUDENTS_PATH = `${ACCOUNT_BASE_PATH}/students`;
export const ACCOUNT_CHECK_IN_CHECK_OUT_PATH = `${ACCOUNT_BASE_PATH}/check_in_check_out`;
export const ACCOUNT_BILLING_PATH = `${ACCOUNT_BASE_PATH}/billing`;
export const ACCOUNT_SUPPORT_PATH = `${ACCOUNT_BASE_PATH}/support`;

export type AccountSectionId =
  | 'user_profile'
  | 'school_profile'
  | 'students'
  | 'check_in_check_out'
  | 'billing'
  | 'support';

export const ACCOUNT_SECTIONS: {
  id: AccountSectionId;
  label: string;
  path: string;
}[] = [
  {
    id: 'user_profile',
    label: 'User Profile',
    path: ACCOUNT_USER_PROFILE_PATH,
  },
  {
    id: 'school_profile',
    label: 'School Profile',
    path: ACCOUNT_SCHOOL_PROFILE_PATH,
  },
  {
    id: 'students',
    label: 'Students',
    path: ACCOUNT_STUDENTS_PATH,
  },
  {
    id: 'check_in_check_out',
    label: 'Check-in / Check-out',
    path: ACCOUNT_CHECK_IN_CHECK_OUT_PATH,
  },
  {
    id: 'billing',
    label: 'Billing',
    path: ACCOUNT_BILLING_PATH,
  },
  {
    id: 'support',
    label: 'Support',
    path: ACCOUNT_SUPPORT_PATH,
  },
];

/** Sections only school owners manage (staff are redirected away). */
export const OWNER_ONLY_ACCOUNT_SECTION_IDS: AccountSectionId[] = [
  'students',
  'billing',
];

export const accountSectionsForRole = (
  schoolRole: 'owner' | 'staff' | 'none' | null | undefined,
) => {
  if (schoolRole === 'staff') {
    return ACCOUNT_SECTIONS.filter(
      (section) => !OWNER_ONLY_ACCOUNT_SECTION_IDS.includes(section.id),
    );
  }
  return ACCOUNT_SECTIONS;
};

export const accountPathForSection = (sectionId: AccountSectionId): string => {
  const section = ACCOUNT_SECTIONS.find((item) => item.id === sectionId);
  return section?.path ?? ACCOUNT_USER_PROFILE_PATH;
};
